import React from 'react'
import ContactBannerImage from "../../asset/guide.png"
const FounderBanner = () => {
  return (
    <div style={{backgroundImage:`url(${ContactBannerImage})`}} className='bg-center flex items-center justify-center h-[400px] bg-cover' >
        <div >
            <h3 className='text-white uppercase text-center font-[LeagueBold] text-[3rem]' >Our Founder</h3>
        </div>
    </div>
  )
}

export default FounderBanner